// LINE ID連携 (/pages/line-alignment). Port nhánh `else` của
// account.line_alignment.php: chưa login thì hiện CTA login (quay lại trang này
// sau login) → đã login thì GET /line/link-url qua inkApi rồi nhảy thẳng sang
// màn hình đồng ý của LINE. Chờ ink:api:ready.
// Callback LINE do Laravel xử lý, đích cuối là /pages/mypage?line=ok|ng.

(function () {
  'use strict';

  function start() {
    const root = document.querySelector('[data-ink-line-alignment]');
    if (!root) return;

    const cfg = window.INK_LINE_ALIGNMENT || {};
    const elLoading = root.querySelector('[data-la-loading]');
    const elLogin = root.querySelector('[data-la-login]');
    const elError = root.querySelector('[data-la-error]');
    const elErrMsg = root.querySelector('[data-la-error-msg]');
    const elLoginLink = root.querySelector('[data-la-login-link]');

    function show(el) {
      [elLoading, elLogin, elError].forEach((e) => { if (e) e.hidden = true; });
      if (el) el.hidden = false;
    }
    function showError(msg) {
      if (elErrMsg && msg) elErrMsg.textContent = msg;
      show(elError);
    }

    // Chưa login → CTA login, quay lại đúng trang này để chạy tiếp.
    const loggedIn = cfg.loggedIn && window.inkApi && window.inkApi.shopifyCustomer;
    if (!loggedIn) {
      if (elLoginLink) {
        const base = cfg.loginUrl || '/customer_authentication/login';
        const ret = window.location.pathname;
        elLoginLink.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'return_to=' + encodeURIComponent(ret);
      }
      show(elLogin);
      return;
    }

    (async () => {
      let res;
      try {
        res = await window.inkApi.get('/line/link-url');
      } catch (e) {
        console.warn('[line-alignment] link-url failed', e);
        showError('通信エラーが発生しました。時間をおいて再度お試しください。');
        return;
      }

      // error = { code, message } (ApiResponse::error). Ưu tiên message của
      // backend: 503 LINE_NOT_CONFIGURED nói rõ đang không dùng được, đừng đổi
      // thành "thử lại sau" vì khách có thử lại cũng vậy.
      const url = res && res.data && res.data.url;
      if (!url) {
        const err = res && res.error;
        showError((err && err.message) || 'LINE ID連携を開始できませんでした。時間をおいて再度お試しください。');
        return;
      }

      // replace: khách bấm Back từ LINE sẽ về trang trước đó, không rơi lại
      // vào trang này rồi tự nhảy sang LINE lần nữa.
      window.location.replace(url);
    })();
  }

  let started = false;
  function startOnce() {
    if (started) return;
    started = true;
    start();
  }

  document.addEventListener('ink:api:ready', startOnce, { once: true });
  window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000));
})();
